"use strict";
/**
 * ==================
 * cookie工具类
 * ==================
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.delLoginCookie = exports.delCookie = exports.setCookie = exports.getCookie = void 0;
/**
 * 取cookie值
 * @param  {string} name cookie名
 * @return {string}      cookie值
 */
function getCookie(name) {
    const arr = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
    return arr ? unescape(arr[2]) : '';
}
exports.getCookie = getCookie;
/**
 * 设置cookie值
 * @param {string} name   cookie名
 * @param {string} value  cookie值
 * @param {string} Days   过期天数
 * @param {string} domain 域名
 */
function setCookie(name, value, Days, domain = '.html5.qq.com') {
    const days = parseInt(Days || '30', 10) || 30;
    const exp = new Date();
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1e3);
    console.log(`[cookie] setCookie|${name}=${value || ''}|${domain}(domain)`);
    document.cookie = `${name}=${value || ''}; domain=${domain}; path=/; expires=${exp.toUTCString()}`;
}
exports.setCookie = setCookie;
/**
 * 删除cookie值
 * @param  {string} name   cookie名
 * @param  {string} domain 域名
 */
function delCookie(name, domain = '.html5.qq.com') {
    if (name) {
        let post;
        let host = domain || window.location.host;
        while ((post = host.indexOf('.')) > -1) { // eslint-disable-line no-cond-assign
            setCookie(name, '', '-1', host);
            host = host.substr(post + 1);
        }
    }
    else {
        document.cookie.split(';').forEach((kv) => {
            const arr = kv.split('=');
            if (arr[0])
                delCookie(arr[0], domain);
        });
    }
}
exports.delCookie = delCookie;
/**
 * 把登录相关的cookie清理掉
 */
function delLoginCookie() {
    ['_n_t_', 'Q-H5-OPENID', 'Q-H5-QBID', 'Q-H5-ID', 'Q-H5-SKEY', 'Q-H5-TOKEN', 'Q-H5-USERTYPE', 'Q-H5-ACCOUNT', 'skey', 'lskey', 'uin', 'luin'].forEach((item) => {
        delCookie(item);
    });
}
exports.delLoginCookie = delLoginCookie;
